const subscribeToConcurrencyInterval = (
    concurrencyInterval$,
    concurrencyApiRequest$
) =>
    concurrencyInterval$
        .subscribe(latestConcurrency => {
            const {
                playerId,
                encryptedLock,
                lockId,
                sequenceToken,
            } = latestConcurrency;

            concurrencyApiRequest$.next({
                playerId,
                encryptedLock,
                lockId,
                sequenceToken,
            });
        });

export default subscribeToConcurrencyInterval;
